export default __webpack_public_path__ + "static/media/bothh.4e5664f7.png";